// extracted by mini-css-extract-plugin
module.exports = {"select":"Selecte133312333fa0a8359e4b9adc127f506"};